const firebaseConfig = {
  apiKey: "AIzaSyAaC4S0EupQmPcZSp2E-RoU0Of-D3CuRv0",
  authDomain: "knowledge-haven.firebaseapp.com",
  projectId: "knowledge-haven",
  storageBucket: "knowledge-haven.appspot.com",
  messagingSenderId: "46187951522",
  appId: "1:46187951522:web:8141a0202b0e7f6149aefb"
};

export default firebaseConfig;